import { React, useState, useEffect, useRef } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import DataTable from "examples/Tables/DataTable";
import AddIcon from "@mui/icons-material/Add";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Dropdown } from "semantic-ui-react";
import { DateInput } from "semantic-ui-calendar-react";
import { ToastContainer, toast } from "react-toastify";
import { Divider } from "@mui/material";
import { useReactToPrint } from "react-to-print";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import DescriptionIcon from "@mui/icons-material/Description";
import { Stack, Typography, Box } from "@mui/material";
import Papa from "papaparse";
import PrintIcon from "@mui/icons-material/Print";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import colors from "assets/theme/base/colors";
import logo from "assets/images/BZU-logo.png";
import { QRCode } from "react-qrcode-logo";
import MDBadge from "components/MDBadge"; // 
import qrcode from "qrcode";
import "../campus/Campus.css";

const { info } = colors;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");

const ITEM_HEIGHT = 50;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function POSVouchers() {
  //Variable Declarations
  const [qrCodeData, setQrCodeData] = useState("");
  const [voucherQRCodeData, setVoucherQRCodeData] = useState(null);
  const [formQRCodeData, setFormQRCodeData] = useState(null);

  const [campaign_id, setCampaignId] = useState("");
  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [mobile_number, setMobileNumber] = useState("");
  const [landline_number, setLandlineNumber] = useState("");
  const [email, setEmail] = useState("");
  const [country, setCountry] = useState("");
  const [sale_type, setSaleType] = useState("");
  const [free_sale, setFreeSale] = useState("");
  const [bank_draft, setBankDraft] = useState("");
  const [voucher_no, setVoucherNo] = useState("");
  const [form_no, setFormNo] = useState("");
  const [expiry_date, setExpiryDate] = useState("");
  const [price, SetPrice] = useState("");
  const [logo_url, setLogoUrl] = useState("");
  const [searchKeyword, setSearchKeyword] = useState("");

  const [vouchers, setVouchers] = useState([]);
  const [countries, setCountries] = useState([]);
  const [all_campaigns, setAllCampaigns] = useState([]);
  const [campaign_ids, setCampaignIds] = useState([]);
  const [campaigns, setCampaigns] = useState([{}]);

  const [free_sale_details, setFreeSaleDetails] = useState(false);
  const [bank_draft_details, setBankDraftDetails] = useState(false);
  const [showAddVoucherModal, setShowAddVoucherModal] = useState(false);
  const [showPrintVoucherModal, setShowPrintVoucherModal] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);

  const [formErrors, setFormErrors] = useState({
    campaign_id,
    first_name,
    last_name,
    mobile_number,
    landline_number,
    email,
    country,
    sale_type,
  });

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setCampaignIds(typeof value === "string" ? value.split(",") : value);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [opens, setOpens] = useState(false);
  const [currentAppId, setCurrentAppId] = useState(null);

  const handleClick = (event, appId) => {
    setAnchorEl(event.currentTarget);
    setOpens(true);
    setCurrentAppId(appId);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpens(false);
    setCurrentAppId(null);
  };

  const handleSearchKeywordChange = (e) => {
    const searchTerm = e.target.value.trim().toLowerCase();
    setSearchKeyword(searchTerm);

    if (searchTerm === "") {
      getVouchersByCampaigns();
    } else {
      let filteredVouchers = vouchers.filter((ent) => {
        const voucherNoMatch =
          ent.voucher_no && ent.voucher_no.toLowerCase().includes(searchTerm);
        const formNoMatch =
          ent.form_no && ent.form_no.toLowerCase().includes(searchTerm);
        const campaignNameMatch =
          ent.campaign_name &&
          ent.campaign_name.toLowerCase().includes(searchTerm);
        const firstNameMatch =
          ent.first_name && ent.first_name.toLowerCase().includes(searchTerm);
        const lastNameMatch =
          ent.last_name && ent.last_name.toLowerCase().includes(searchTerm);
        const emailMatch =
          ent.email && ent.email.toLowerCase().includes(searchTerm);
        const mobileNoMatch =
          ent.mobile_number &&
          ent.mobile_number.toLowerCase().includes(searchTerm);
        const saleTypeMatch =
          ent.sale_type && ent.sale_type.toLowerCase().includes(searchTerm);
        const saleDateMatch =
          ent.saleDateFormatted &&
          ent.saleDateFormatted.toLowerCase().includes(searchTerm);

        return (
          voucherNoMatch ||
          formNoMatch ||
          campaignNameMatch ||
          firstNameMatch ||
          lastNameMatch ||
          emailMatch ||
          mobileNoMatch ||
          saleTypeMatch ||
          priceMatch ||
          saleDateMatch
        );
      });

      setVouchers(filteredVouchers);
    }
  };

  const callErrors = (
    CAMPAIGNID,
    FIRSTNAME,
    LASTNAME,
    MOBILENUMBER,
    LANDLINENUMBER,
    EMAIL,
    COUNTRY,
    SALETYPE
  ) => {
    const errors = {};
    if (CAMPAIGNID === "") {
      errors.campaign_id = " * Select a Campaign";
    }
    if (FIRSTNAME === "") {
      errors.first_name = " * First Name is Required";
    }
    if (LASTNAME === "") {
      errors.last_name = " * Last Name is Required";
    }
    if (MOBILENUMBER === "") {
      errors.mobile_number = " * Mobile Number is Required";
    }
    if (LANDLINENUMBER === "") {
      errors.landline_number = " * Landline Number is Required";
    }
    if (EMAIL === "") {
      errors.email = " * Email is Required";
    }
    if (COUNTRY === "") {
      errors.country = " * Please Select a Country";
    }
    if (SALETYPE === "") {
      errors.sale_type = " * Please Select a Sale Type";
    }

    setFormErrors(errors);
  };

  const handleFocus = (e) => {
    const { name } = e.target;

    setFormErrors((prevFormErrors) => ({
      ...prevFormErrors,
      [name]: "",
    }));
  };

  const handleSaleTypeChange = (value) => {
    setSaleType(value);
    if (value === "Free") {
      setFreeSaleDetails(true);
      setBankDraftDetails(false);
    } else if (value === "Bank Draft") {
      setBankDraftDetails(true);
      setFreeSaleDetails(false);
    } else {
      setFreeSaleDetails(false);
      setBankDraftDetails(false);
    }
  };

  const componentRef = useRef();
  const handlePrint = (voucher) =>
    useReactToPrint({
      content: () => componentRef.current,
      documentTitle: `Voucher-${currentAppId}`,
      onAfterPrint: () => console.log("Printed PDF successfully!"),
    });

  const handleOnClickPrint = () => {
    window.open(`/test-slip/${currentAppId}/`);
  };

  const columns = [
    { Header: "Sr.No", accessor: "serial", align: "center" },
    { Header: "Voucher #", accessor: "voucher_no", align: "left" },
    { Header: "Form #", accessor: "form_no", align: "center" },
    { Header: "Campaign Name", accessor: "campaign_name", align: "center" },
    { Header: "Name", accessor: "name", align: "center" },
    { Header: "Email", accessor: "email", align: "center" },
    { Header: "Mobile #", accessor: "mobile_number", align: "center" },
    { Header: "Sale Type", accessor: "sale_type", align: "center" },
    { Header: "Price", accessor: "price", align: "center" },
    { Header: "Voucher Used", accessor: "is_used", align: "center" },
    { Header: "Sale Date", accessor: "sale_date", align: "center" },
    { Header: "Expiry Date", accessor: "expiry_date", align: "center" },
    { Header: "POS User", accessor: "pos_user", align: "center" },
  ];

  const rows =
    vouchers.length > 0
      ? vouchers.map((vouch, index) => {
          const saleDate = new Date(vouch.createdAt);
          const saleDateFormatted = `${saleDate.getDate()}-${
            saleDate.getMonth() + 1
          }-${saleDate.getFullYear()}`;

          const expiryDate = vouch.expiry_date.split(' ')[0];
          const badgeColor = vouch.is_used === 1 ? "success" : "error";
          const usageStatus = vouch.is_used === 1 ? "Used" : "Not Used";
          
          return {
            serial: index + 1,
            voucher_no: vouch.voucher_no,
            form_no: vouch.form_no,
            campaign_name: vouch.campaign_name,
            name: vouch.first_name + vouch.last_name,
            email: vouch.email,
            mobile_number: vouch.mobile_number,
            sale_type: vouch.sale_type,
            price: vouch.price,
            is_used: (
              <MDBox ml={-1}>
                <MDBadge
                  badgeContent={usageStatus}
                  color={badgeColor}
                  variant="gradient"
                  size="sm"
                />
              </MDBox>
            ),
            sale_date: saleDateFormatted,
            expiry_date: expiryDate,
            pos_user: vouch.pos_user,
            // actions: (
            //   <>
            //     <IconButton
            //       aria-label="print"
            //       onClick={() => handlePrint(app.voucher_no)}
            //     >
            //       <PrintIcon style={{ color: "green" }} />
            //     </IconButton>
            //   </>
            // ),
          };
        })
      : [
          {
            serial: null,
            voucher_no: null,
            form_no: null,
            campaign_name: null,
            name: null,
            email: null,
            mobile_number: null,
            sale_type: null,
            is_used: null,
            sale_date: null,
            expiry_date: null,
            pos_user: null,
          },
        ];

  const csvcolumns = [
    { Header: "Sr.No", accessor: "serial", align: "center" },
    { Header: "Voucher #", accessor: "voucher_no", align: "left" },
    { Header: "Form #", accessor: "form_no", align: "center" },
    { Header: "Campaign Name", accessor: "campaign_name", align: "center" },
    { Header: "First Name", accessor: "first_name", align: "center" },
    { Header: "Last Name", accessor: "last_name", align: "center" },
    { Header: "Email", accessor: "email", align: "center" },
    { Header: "Mobile #", accessor: "mobile_number", align: "center" },
    { Header: "Landline #", accessor: "landline_number", align: "center" },
    { Header: "Sale Type", accessor: "sale_type", align: "center" },
    { Header: "Price", accessor: "price", align: "center" },
    { Header: "Voucher Used", accessor: "is_used", align: "center" },
    { Header: "Sale Date", accessor: "sale_date", align: "center" },
    { Header: "Expiry Date", accessor: "expiry_date", align: "center" },
    { Header: "POS User", accessor: "pos_user", align: "center" },
  ];

  const csvrows =
    vouchers.length > 0
      ? vouchers.map((vouch, index) => {
          const saleDate = new Date(vouch.created_at);
          const saleDateFormatted = `${saleDate.getDate()}-${
            saleDate.getMonth() + 1
          }-${saleDate.getFullYear()}`;

          return {
            serial: index + 1,
            voucher_no: vouch.voucher_no,
            form_no: vouch.form_no,
            campaign_name: vouch.campaign_name,
            first_name: vouch.first_name,
            last_name: vouch.last_name,
            email: vouch.email,
            mobile_number: vouch.mobile_number,
            landline_number: vouch.landline_number,
            sale_type: vouch.sale_type,
            price: vouch.price,
            is_used: vouch.is_used,
            sale_date: saleDateFormatted,
            expiry_date: vouch.expiry_date,
            pos_user: vouch.pos_user,
          };
        })
      : [
          {
            serial: null,
            voucher_no: null,
            form_no: null,
            campaign_name: null,
            name: null,
            email: null,
            mobile_number: null,
            sale_type: null,
            is_used: null,
            price: null,
            sale_date: null,
            expiry_date: null,
            pos_user: null,
          },
        ];

  const handleExportCSV = () => {
    const data = [
      csvcolumns.map((col) => col.Header),
      ...csvrows.map((row) => Object.values(row)),
    ];

    const csv = Papa.unparse(data);

    const blob = new Blob([csv], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "POS-Vouchers.csv";

    link.click();
  };

  //Dialog Settings
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("xl"));
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState("md");

  //Session Storage Rendering
  var user = JSON.parse(sessionStorage.getItem("user"));
  if (user) {
    var organization_id = user.organization_id;
  } else {
    var organization_id = null;
  }

  const handleCampaigns = (event, data) => {
    const { value } = data;
    const selectedCampaigns = Array.isArray(value) ? value : [value];

    setCampaignIds(selectedCampaigns);
  };

  // GET API Calls
  const getCampaigns = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(BASE_URL + `/campaign/get_active_campaigns`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setCampaigns(data.campaigns);
      })
      .catch((error) => console.log(error));
  };

  const getAllCampaigns = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(BASE_URL + `/campaign/get_campaigns`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setAllCampaigns(data.campaigns);
      })
      .catch((error) => console.log(error));
  };

  const getVouchersByCampaigns = async () => {
    let data = { campaign_ids: campaign_ids };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };
    await fetch(
      BASE_URL + `/admission_voucher/get_voucher_by_campaigns`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        setVouchers(data.vouchers);
      })
      .catch((error) => console.log(error));
  };

  const getVouchersByFormNo = async () => {
    setShowFilterModal(false);
    let data = { form_no: form_no };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };
    await fetch(
      BASE_URL + `/admission_voucher/get_voucher_by_form_no`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        setVouchers(data.vouchers);
      })
      .catch((error) => console.log(error));
  };

  const getVouchersByVoucherNo = async () => {
    setShowFilterModal(false);
    let data = { voucher_no: voucher_no };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };
    await fetch(
      BASE_URL + `/admission_voucher/get_voucher_by_voucher_no`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        setVouchers(data.vouchers);
      })
      .catch((error) => console.log(error));
  };

  const getVouchersByMobileNo = async () => {
    setShowFilterModal(false);
    let data = { mobile_number: mobile_number };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };
    await fetch(
      BASE_URL + `/admission_voucher/get_vouchers_by_mobile`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        setVouchers(data.vouchers);
      })
      .catch((error) => console.log(error));
  };

  const getCountries = async () => {
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };
    try {
      const response = await fetch(`${BASE_URL}/getCountries`, requestOptions);
      const data = await response.json();
      setCountries(data.countries);
    } catch (error) {
      console.error(error);
    }
  };

  // Add Functions
  const showVoucherAddModal = () => {
    setShowAddVoucherModal(true);
  };

  const handleCancelAddVoucherModal = () => {
    setShowAddVoucherModal(false);
    setFormErrors({
      campaign_id: "",
      first_name: "",
      last_name: "",
      mobile_number: "",
      landline_number: "",
      email: "",
      country: "",
      sale_type: "",
    });
  };

  const showVoucherPrintModal = () => {
    setShowPrintVoucherModal(true);
  };
  const handleOkPrintVoucherModal = () => {};
  const handleCancelPrintVoucherModal = () => {
    setShowPrintVoucherModal(false);
  };

  const showFiltersModal = () => {
    setShowFilterModal(true);
  };
  const handleOkFilterModal = () => {
    setVoucherNo("");
    setFormNo("");
    setMobileNumber("");
    setShowFilterModal(false);
  };
  const handleCancelFilterModal = () => {
    setVoucherNo("");
    setFormNo("");
    setMobileNumber("");
    setShowFilterModal(false);
  };

  const handleOkAddVoucherModal = () => {
    if (
      campaign_id &&
      first_name &&
      last_name &&
      mobile_number &&
      landline_number &&
      email &&
      country &&
      sale_type
    ) {
      addVoucher();
      setShowAddVoucherModal(false);
    } else {
      callErrors(
        campaign_id,
        first_name,
        last_name,
        mobile_number,
        landline_number,
        email,
        country,
        sale_type
      );
    }
  };

  const addVoucher = async () => {
    let data = {
      campaign_id,
      first_name,
      last_name,
      mobile_number,
      landline_number,
      email,
      country,
      sale_type,
      free_sale,
      bank_draft,
    };
    console.log("Voucher Data", data);
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };

    await fetch(
      `${BASE_URL}/admission_voucher/add_admission_voucher`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        setVoucherNo(data.voucher_no);
        setFormNo(data.form_no);
        setExpiryDate(data.expiry_date);
        setLogoUrl(data.logo_url);
        SetPrice(data.price);
        setVoucherNo(data.voucher_no);
        // Generate QR code for both voucher_no and form_no together
        if (data.voucher_no && data.form_no) {
          generateQRCode(data.voucher_no, data.form_no);
        }

        showVoucherPrintModal();
      })
      .catch((error) => console.log(error))
      .finally(() => {});
  };

  const generateQRCode = async (voucherNo, formNo) => {
    try {
      const combinedData = `${voucherNo} | ${formNo}`;

      const qrCodeData = await qrcode.toDataURL(combinedData);

      setQrCodeData(qrCodeData);
    } catch (error) {
      console.error("Error generating QR code:", error.message);
    }
  };

  // Initial Renderings
  useEffect(() => {
    getCampaigns();
    // getCountries();
    getAllCampaigns();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />

      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <label style={{ paddingLeft: "20px" }}>Campaign</label>
            <Stack
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              paddingRight={2}
              paddingLeft={2}
            >
              <div className="col-md-3 dropdown-container">
                <Dropdown
                  id="filter_campaign_id"
                  name="filter_campaign_id"
                  placeholder="Select Campaign"
                  fluid
                  selection
                  multiple={true}
                  search
                  value={campaign_ids}
                  onChange={handleCampaigns}
                  options={all_campaigns.map((camp) => ({
                    key: camp.id,
                    text: camp.name,
                    value: camp.id,
                  }))}
                   className="form-control form-control-md2"
                />
              </div>
              <Button
                variant="contained"
                endIcon={<SearchIcon className="add-icon" />}
                onClick={getVouchersByCampaigns}
                className="add-full-button mb-3"
              >
                Get Vouchers
              </Button>
            </Stack>

            <Card className="mt-5 card1">
              <MDBox
                mx={0}
                mt={0}
                py={2}
                px={2}
                variant="gradient"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDBox
                  display="flex"
                  alignItems="center"
                  sx={{ width: "100%" }}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={1}
                    sx={{ width: "100%" }}
                  >
                    <Stack sx={{ flexGrow: 1 }}>
                      <Paper component="form" className="search-paper">
                        <InputBase
                          sx={{ ml: 1, flex: 1, fontSize: "16px" }}
                          placeholder="Search"
                          inputProps={{ "aria-label": "search voucher" }}
                          value={searchKeyword}
                          onChange={handleSearchKeywordChange}
                        />
                        <SearchIcon className="search-icon" />
                      </Paper>
                    </Stack>

                    {/* Buttons stack aligned to the right */}
                    <Stack direction="row" spacing={1}>
                      <Button
                        variant="filled"
                        endIcon={<AddIcon className="add-icon" />}
                        onClick={showVoucherAddModal}
                        className="add-full-button"
                      >
                        Generate Voucher
                      </Button>
                      <Button
                        variant="filled"
                        endIcon={<FilterAltIcon className="add-icon" />}
                        onClick={showFiltersModal}
                        className="add-full-button"
                      >
                        Filter
                      </Button>
                      <Button
                        variant="filled"
                        endIcon={<DescriptionIcon className="add-icon" />}
                        onClick={handleExportCSV}
                        className="add-full-button"
                      >
                        Export CSV
                      </Button>
                    </Stack>
                  </Stack>
                </MDBox>
              </MDBox>
              <MDBox pt={3}>
                {vouchers && vouchers.length > 0 ? (
                  <DataTable
                    table={{ columns, rows }}
                    pagination={false}
                    autoHeight
                  />
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <img
                      src="nodata.png"
                      style={{
                        display: "block",
                        margin: "auto",
                        width: "20%",
                        height: "20%",
                      }}
                    />
                  </div>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* Generate Voucher */}
      <Dialog
        // fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={showAddVoucherModal}
        onClose={handleCancelAddVoucherModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          className: "dialog-paper",
        }}
      >
        <DialogTitle id="alert-dialog-title" className="dialog-title">
          {"Generate Voucher"}
        </DialogTitle>
        <DialogContent className="dialog-content">
          <div className="row">
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Active Campaigns</label>
                <Dropdown
                  id="campaign_id"
                  name="campaign_id"
                  placeholder="Select Active Campaign"
                  fluid
                  selection
                  value={campaign_id}
                  onChange={(e, { value }) => setCampaignId(value)}
                  onFocus={handleFocus}
                  options={campaigns.map((camp) => ({
                    key: camp.id,
                    text: camp.name,
                    value: camp.id,
                  }))}
                  className="custom-dropdown"
                />
              </div>
              <div className="error-message1">{formErrors.campaign_id}</div>
            </div>

            <Divider variant="middle" component="li" />

            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>First Name</label>
                <input
                  name="first_name"
                  type="text"
                  value={first_name}
                  onChange={(e) => setFirstName(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter First Name"
                />
              </div>
              <div className="error-message1">{formErrors.first_name}</div>
            </div>

            <div className="col-md-6">
              <div className="mt-3">
                <label>Last Name</label>
                <input
                  name="last_name"
                  type="text"
                  value={last_name}
                  onChange={(e) => setLastName(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Last Name"
                />
              </div>
              <div className="error-message">{formErrors.last_name}</div>
            </div>

            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Mobile Number</label>
                <input
                  name="mobile_number"
                  type="number"
                  value={mobile_number}
                  onChange={(e) => setMobileNumber(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Mobile Number"
                />
              </div>
              <div className="error-message1">{formErrors.mobile_number}</div>
            </div>

            <div className="col-md-6">
              <div className="mt-3">
                <label>Landline Number</label>
                <input
                  name="landline_number"
                  type="number"
                  value={landline_number}
                  onChange={(e) => setLandlineNumber(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Landline Number"
                />
              </div>
              <div className="error-message">{formErrors.landline_number}</div>
            </div>

            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Country of Origin</label>
                <input
                  name="country"
                  type="text"
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Country of Origin"
                />
              </div>
              <div className="error-message1">{formErrors.country}</div>
            </div>

            <div className="col-md-6">
              <div className="mt-3">
                <label>Email</label>
                <input
                  name="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Email Address"
                />
              </div>
              <div className="error-message">{formErrors.email}</div>
            </div>

            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Sale Type</label>
                <Dropdown
                  id="sale_type"
                  name="sale_type"
                  placeholder="Select Sale Type"
                  fluid
                  selection
                  value={sale_type}
                  onChange={(e, { value }) => handleSaleTypeChange(value)}
                  onFocus={handleFocus}
                  options={[
                    {
                      key: "",
                      text: "",
                      value: "",
                    },
                    {
                      key: "1",
                      text: "Normal/Cash",
                      value: "Normal/Cash",
                    },
                    {
                      key: "2",
                      text: "Free",
                      value: "Free",
                    },
                    {
                      key: "3",
                      text: "Bank Draft",
                      value: "Bank Draft",
                    },
                  ]}
                  className="custom-dropdown"
                />
              </div>
              <div className="error-message1">{formErrors.sale_type}</div>
            </div>

            {free_sale_details ? (
              <div className="col-md-12">
                <div className="form-outline mt-3">
                  <label>Free Sale Details</label>
                  <input
                    name="free_sale"
                    type="text"
                    value={free_sale}
                    onChange={(e) => setFreeSale(e.target.value)}
                    onFocus={handleFocus}
                    className="form-control form-control-lg"
                    placeholder="Enter Free Sale Details"
                  />
                </div>
              </div>
            ) : bank_draft_details ? (
              <div className="col-md-12">
                <div className="form-outline mt-3">
                  <label>Bank Draft Details</label>
                  <input
                    name="bank_draft"
                    type="text"
                    value={bank_draft}
                    onChange={(e) => setBankDraft(e.target.value)}
                    onFocus={handleFocus}
                    className="form-control form-control-lg"
                    placeholder="Enter Bank Draft Details"
                  />
                </div>
              </div>
            ) : null}
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className="dialog-actions-button negative"
            onClick={handleCancelAddVoucherModal}
          >
            Cancel
          </Button>
          <Button
            className="dialog-actions-button positive"
            onClick={handleOkAddVoucherModal}
            autoFocus
          >
            Done
          </Button>
        </DialogActions>
      </Dialog>

      {/* Prospectus fee Recipet */}
      <Dialog
        // fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={showPrintVoucherModal}
        onClose={handleCancelPrintVoucherModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent ref={componentRef} className="dialog-reciept">
          <Stack spacing={3}>
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              justifyContent="space-between"
            >
              <Box>
                <img
                  src={logo}
                  alt="Admission System"
                  className="admission-logo"
                />
              </Box>
              <Box flexGrow={1} display="flex" justifyContent="center">
                <Typography
                  variant="h4"
                  component="h2"
                  align="center"
                  color="textPrimary"
                  className="reciept-title"
                >
                  Prospectus Fee Receipt
                </Typography>
              </Box>
              <Box>
                {qrCodeData && (
                  <img
                    src={qrCodeData}
                    alt="Generated QR Code"
                    className="w-40 h-40 object-contain"
                  />
                )}
              </Box>
            </Stack>

            <Divider className="reciept-divider" />

            <Box mt={2} ml={3} width="100%">
              <Stack spacing={8} direction="row">
                <Typography
                  variant="h6"
                  color="textPrimary"
                  className="reciept-form"
                >
                  <strong>Name:</strong> {first_name} {last_name}
                </Typography>
                <Typography
                  variant="h6"
                  color="textPrimary"
                  className="reciept-form"
                >
                  <strong>Phone:</strong> {mobile_number}
                </Typography>
              </Stack>

              <Stack spacing={3} direction="row">
                <Typography
                  variant="h6"
                  color="textPrimary"
                  className="reciept-form"
                >
                  <strong>Voucher No:</strong> {voucher_no}
                </Typography>
                <Typography
                  variant="h6"
                  color="textPrimary"
                  className="reciept-form"
                >
                  <strong>Form No:</strong> {form_no}
                </Typography>
              </Stack>
            </Box>

            <Typography variant="h6" color="textPrimary" className="some-typo">
              <strong>Expiry Date:</strong> {expiry_date.split("T")[0]}
            </Typography>

            <Divider className="reciept-divider" />
            <Typography variant="h3" color="textPrimary" className="some-typo">
              <strong>Price:</strong> {price}
            </Typography>
            <Divider className="reciept-divider" />
            <Box mt={2} ml={3} width="100%">
              <Typography variant="subtitle2" className="text-title">
                1.{" "}
                <span className="fee-text">
                Ensure that the voucher is used within the specified expiry date.
                </span>
              </Typography>
              <Typography variant="subtitle2" className="text-title">
                2.{" "}
                <span className="fee-text">
                Do not share this voucher with anyone.
                </span>
              </Typography>
              <Typography variant="subtitle2" className="text-title">
                3.{" "}
                <span className="fee-text">
                Any modification to this voucher is strictly prohibited.
                </span>
              </Typography>
            </Box>
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button
            className="dialog-actions-button negative"
            onClick={handleCancelPrintVoucherModal}
            autoFocus
          >
            Close
          </Button>
          <Button
            className="dialog-actions-button positive"
            onClick={handlePrint(voucher_no)}
            autoFocus
          >
            Print
          </Button>
        </DialogActions>
      </Dialog>

      {/* Filter */}
      <Dialog
        // fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={showFilterModal}
        onClose={handleCancelFilterModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <>
            <div>
              <div>
                <label>Voucher No</label>
                <Paper
                  component="form"
                  sx={{
                    p: "2px 4px",
                    display: "flex",
                    alignItems: "center",
                    width: 400,
                  }}
                >
                  <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Enter Voucher Number"
                    inputProps={{ "aria-label": "search voucher" }}
                    value={voucher_no}
                    onChange={(e) => setVoucherNo(e.target.value)}
                  />
                  <IconButton
                    type="button"
                    sx={{ p: "10px" }}
                    onClick={getVouchersByVoucherNo}
                    aria-label="search"
                  >
                    <SearchIcon />
                  </IconButton>
                </Paper>
              </div>

              <div className="mt-4">
                <label>Form No</label>
                <Paper
                  component="form"
                  sx={{
                    p: "2px 4px",
                    display: "flex",
                    alignItems: "center",
                    width: 400,
                  }}
                >
                  <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Enter Form Number"
                    inputProps={{ "aria-label": "search voucher" }}
                    value={form_no}
                    onChange={(e) => setFormNo(e.target.value)}
                  />
                  <IconButton
                    type="button"
                    sx={{ p: "10px" }}
                    onClick={getVouchersByFormNo}
                    aria-label="search"
                  >
                    <SearchIcon />
                  </IconButton>
                </Paper>
              </div>

              <div className="mt-4">
                <label>Mobile No</label>
                <Paper
                  component="form"
                  sx={{
                    p: "2px 4px",
                    display: "flex",
                    alignItems: "center",
                    width: 400,
                  }}
                >
                  <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Enter Mobile Number"
                    inputProps={{ "aria-label": "search voucher" }}
                    value={mobile_number}
                    onChange={(e) => setMobileNumber(e.target.value)}
                  />
                  <IconButton
                    type="button"
                    sx={{ p: "10px" }}
                    onClick={getVouchersByMobileNo}
                    aria-label="search"
                  >
                    <SearchIcon />
                  </IconButton>
                </Paper>
              </div>
            </div>
          </>
        </DialogContent>

        <DialogActions>
          <Button
            className="dialog-actions-button negative"
            onClick={handleCancelFilterModal}
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default POSVouchers;
